import { forwardRef, type HTMLAttributes } from 'react';
import cn from 'classnames';
import { motion, type Variants } from 'framer-motion';

import { MotionChevronIcon } from './MotionChevronIcon';

interface ChevronsAnimationProps extends HTMLAttributes<HTMLDivElement> {
  height?: string | number;
  width?: string | number;
}

const ChevronsAnimation = forwardRef<HTMLDivElement, ChevronsAnimationProps>(
  ({ width, height, ...props }, ref) => {
    const variants: Variants = {
      initial: { opacity: 0.3 },
      animate: (index: number) => ({
        opacity: [0.3, 1, 0.3], // fade in -> fade out
        transition: {
          duration: 0.25 * 2 + 0.5,
          times: [0, 0.3, 1], // 0 -> 1 -> 0
          delay: index * 0.5 + 0.5,
          repeatDelay: 0.66,
          repeat: Infinity,
          repeatType: 'loop',
        },
      }),
    };

    return (
      <div ref={ref} {...props} className={cn('flex', props.className)}>
        {Array.from({ length: 3 }).map((_, index) => (
          <div key={index} className="flex-1 h-full relative">
            <motion.div
              custom={index}
              variants={variants}
              initial="initial"
              animate="animate"
              className="absolute top-0 left-1/2 -translate-x-1/2 aspect-square h-full"
            >
              <MotionChevronIcon className="h-full aspect-square !text-gold" />
            </motion.div>
          </div>
        ))}
      </div>
    );
  },
);

export { ChevronsAnimation };
